/**
 * Desktop sidebar collapse preference.
 * Key follows the existing `multi-chat:*` localStorage convention.
 * Tablet/mobile responsive layout must not write this value.
 */
export const SIDEBAR_COLLAPSED_STORAGE_KEY = "multi-chat:sidebar-collapsed";

/** Default for first-time users: expanded desktop rail → collapsed = false. */
export const SIDEBAR_COLLAPSED_DEFAULT = false;

/**
 * Reads the persisted desktop preference.
 * Returns false (expanded) when missing, malformed, or storage is unavailable.
 */
export function readSidebarCollapsedPreference(): boolean {
  try {
    const raw = window.localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY);
    if (raw === "true") return true;
    if (raw === "false") return false;
    return SIDEBAR_COLLAPSED_DEFAULT;
  } catch {
    return SIDEBAR_COLLAPSED_DEFAULT;
  }
}

/** Persists an explicit desktop preference as "true" | "false". */
export function writeSidebarCollapsedPreference(collapsed: boolean): void {
  try {
    window.localStorage.setItem(
      SIDEBAR_COLLAPSED_STORAGE_KEY,
      collapsed ? "true" : "false",
    );
  } catch {
    // Quota / private mode — preference stays in-memory only.
  }
}
